// extracted by mini-css-extract-plugin
export default {"button":"Button_button__DzBpu","button_disabled":"Button_button_disabled__bUb28"};